import React, { useRef, useEffect } from 'react'
import styles from './DropdownListItemLink.module.css'

interface DropdownListItemLinkProps {
  item: any
  active: boolean
  parent: string
}

export const DropdownListItemLink: React.FC<DropdownListItemLinkProps> = ({
  item,
  active,
  parent,
}) => {
  const linkRef = useRef<HTMLAnchorElement>(null)

  useEffect(() => {
    if (linkRef.current && active) {
      linkRef.current.focus()
    }
  }, [linkRef, active])

  const getClassName = () => {
    if (parent === 'profileDropdown') {
      return styles.profileDropdown
    }
    if (parent === 'navigationButton') {
      return styles.navigationButton
    }
  }

  return (
    <a
      key={item.title.trim()}
      href={item.url}
      ref={linkRef}
      className={`${getClassName()} ${item.classNames}`}
      data-enable-spinner={item.dataEnableSpinner}
      data-js={item.dataJS}
      data-bypass={item.dataBypass}
    >
      {item.title}
    </a>
  )
}
